export let NotificationType = /*#__PURE__*/function (NotificationType) {
  NotificationType["INFO"] = "INFO";
  NotificationType["WARNING"] = "WARNING";
  NotificationType["ERROR"] = "ERROR";
  NotificationType["SUCCESS"] = "SUCCESS";
  return NotificationType;
}({});
export let NotificationActionType = /*#__PURE__*/function (NotificationActionType) {
  NotificationActionType["ADD"] = "ADD";
  NotificationActionType["REMOVE"] = "REMOVE";
  NotificationActionType["CLEAR"] = "CLEAR";
  return NotificationActionType;
}({});
//# sourceMappingURL=types.js.map